import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'

import { faqInfo } from '../lib/faq-data'

import styles from './subscription.module.scss'

export const FaqSection = () => {
    return (
        <Box width='100%' textAlign='start' marginTop={'50px'}>
            <Typography className={styles.title} sx={{ paddingBottom: '20px' }}>
                Частые вопросы
            </Typography>
            {faqInfo.map((el, index) => {
                return (
                    <Box key={el.title}>
                        <Accordion
                            sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}
                        >
                            <AccordionSummary
                                sx={{
                                    '& .MuiAccordionSummary-expandIconWrapper': {
                                        color: '#646464',
                                    },
                                    '& .MuiAccordionSummary-content': {
                                        '& p': {
                                            color: '#FFFFFF',
                                        },
                                    },
                                    '&.Mui-expanded': {
                                        '& .MuiAccordionSummary-content': {
                                            '& p': {
                                                color: '#8280FF',
                                            },
                                        },
                                    },
                                }}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls='panel1a-content'
                                id='panel1a-header'
                            >
                                <Typography className={styles.accordionTitle}>{el.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography className={styles.accordionText}>{el.text}</Typography>
                            </AccordionDetails>
                        </Accordion>
                        {index < faqInfo.length - 1 && (
                            <Box
                                component='hr'
                                className={styles.accordionDivider}
                            />
                        )}
                    </Box>
                )
            })}
        </Box>
    )
}

